module.exports = __webpack_public_path__ + "img/introduce_content_4_ug.e4ac2beb.png";